module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-900italic.43b527fe77254f97ea36e2b54e845ec4.woff";